import {Injectable, NgZone} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {ToastType} from "../actions/core.actions";
import {ClickableToast} from "../components/clickable-toast/clickable-toast";

@Injectable({ providedIn: 'root' })
export class ToastrHelper {

  constructor(
    private toastrService: ToastrService,
    private ngZone:NgZone
  ) { }
  showErrorToast(message:any): void {
    this.showToast({
      content:message,
      title :"Error",
      timeout: 8000,
      closeButton: true,
      progressBar: true
    })
  }
  showToast(message:any): void {
    switch ( message.style) {
      case ToastType.Success:
        this.toastrService.success(message.content, message.title, { timeOut: message.timeout, closeButton: message.closeable, progressBar: true });
        break;
      case ToastType.Error:
        this.toastrService.error(message.content, message.title, { timeOut: message.timeout, closeButton: message.closeable, progressBar: true });
        break;
      case ToastType.Info:
        this.toastrService.info(message.content, message.title, { timeOut: message.timeout, closeButton: message.closeable, progressBar: true });
        break;
      case ToastType.Warning:
        this.toastrService.warning(message.content, message.title, { timeOut: message.timeout, closeButton: message.closeable, progressBar: true });
        break;
      case ToastType.Default:
        this.toastrService.info(message.content, message.title, { timeOut: message.timeout, closeButton: message.closeable, progressBar: true });
        break;
      case ToastType.Clickable:
        this.ngZone.run(()=> {
          this.toastrService.warning(message.content, message.title, { timeOut: message.timeout, closeButton: message.closeable, progressBar: true, toastComponent:ClickableToast });
        })
        break;
    }
  }

}
